(function() {
  var datenEl = document.querySelector("[data-nbx-daten]");
  if (!datenEl) return;
  var DATEN;
  try {
    DATEN = JSON.parse(datenEl.textContent);
  } catch (e) {
    return;
  }
  var FENSTER_STD = DATEN.fensterStunden || 8, LEISTE_KNOPF = DATEN.knopfText || "Bestellung prüfen", host = document.querySelector("[data-basis]");
  if (!host) return;
  var BASIS = (host.dataset.basis || "").replace(/\/+$/, ""), katNach = {};
  DATEN.kategorien.forEach(function(k) {
    katNach[k.titel] = k;
  });
  function el(tag, klasse, text) {
    var n = document.createElement(tag);
    return klasse && (n.className = klasse), text != null && (n.textContent = text), n;
  }
  function geld(x) {
    try {
      return x.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
    } catch (e) {
      return x.toFixed(2).replace(".", ",") + " €";
    }
  }
  function preisZahl(s) {
    var m = String(s || "").replace(/[^0-9,.]/g, "").replace(/\.(?=\d{3}\b)/g, "").replace(",", "."), n = parseFloat(m);
    return isNaN(n) ? 0 : n;
  }
  function infoZu(titel) {
    if (DATEN.produkte[titel]) return DATEN.produkte[titel];
    var kurz = titel.split(" · ")[0];
    return DATEN.produkte[kurz] || null;
  }
  function kategorieVon(titel) {
    for (var kurz = titel.split(" · ")[0], i = 0; i < DATEN.kategorien.length; i++) {
      var k = DATEN.kategorien[i];
      if (k.produkte.indexOf(titel) > -1 || k.produkte.indexOf(kurz) > -1) return k.titel;
    }
    return null;
  }
  var aktuell = null;
  function portal() {
    return window.NicoPortal || null;
  }
  function abgeschlossen() {
    return !!(aktuell && aktuell.abschluss && aktuell.abschluss.am);
  }
  document.addEventListener("nico:laden", function() {
    if (leisteKnopf) leisteKnopf.disabled = true;
    var dialog = document.querySelector(".nbx__dialog");
    if (dialog && dialog.parentNode) dialog.parentNode.removeChild(dialog);
  });
  document.addEventListener("nico:bestellung", function(e) {
    aktuell = e.detail || null, summeMalen();
  });
  function kurzTitel(titel) {
    return titel.replace(/^NICO\s+/i, "").replace(/^Salat to Go XL,\s*/i, "").replace(/^Breakfast Bowl,\s*/i, "").replace(/\s*\(vegan\)/i, "").replace(/\s*\d+\s*(g|ml)\s*$/i, "");
  }
  function produktDetails(info, text) {
    if (!info.allergene && !info.url && !info.zutaten) return;
    var knopf = el("button", "nbx__details-knopf", "Zutaten & Allergene");
    knopf.type = "button"; knopf.setAttribute("aria-haspopup", "dialog");
    knopf.addEventListener("click", function() {
      var dialog = el("div", "nbx__dialog"), blatt = el("div", "nbx__blatt nbx__zutaten-blatt");
      var titel = el("h3", null, "Das ist drin");
      var kopf = el("div", "nbx__dialog-kopf"); kopf.appendChild(titel);
      var zu = el("button", "nbx__dialog-schliessen", "×"); zu.type = "button"; zu.setAttribute("aria-label", "Schließen"); kopf.appendChild(zu);
      blatt.appendChild(kopf);
      var schliessen = dialogStart(dialog, blatt, titel); zu.addEventListener("click", schliessen);
      var produkt = el("div", "nbx__zutaten-produkt");
      if (info.bild) { var bild = el("img", "nbx__zutaten-bild"); bild.src = info.bild; bild.alt = ""; produkt.appendChild(bild); }
      produkt.appendChild(el("strong", null, info.titel || "Ihre Bowl")); blatt.appendChild(produkt);
      var zutaten = Array.isArray(info.zutaten) ? info.zutaten : info.zutaten ? [info.zutaten] : [];
      if (zutaten.length) {
        var liste = el("ul", "nbx__zutaten-liste");
        zutaten.forEach(function(z) { liste.appendChild(el("li", null, z)); }); blatt.appendChild(liste);
      } else blatt.appendChild(el("p", "nbx__blatt-sub", "Die vollständigen Zutaten finden Sie auf der Produktseite."));
      if (info.allergene) blatt.appendChild(el("p", "nbx__zutaten-allergene", "Allergene: " + info.allergene));
      if (info.naehrwertBasis && (info.kcal || info.protein)) {
        var werte = [info.kcal ? info.kcal + " kcal" : "", info.protein ? String(info.protein).replace(/\s*g$/i, " g") + " Protein" : ""].filter(Boolean);
        blatt.appendChild(el("p", "nbx__zutaten-naehr", werte.join(" · ") + " · " + (info.naehrwertHinweis || info.naehrwertBasis)));
      }
      if (info.url) { var link = el("a", "nbx__zutaten-link", "Zur vollständigen Produktseite ↗"); link.href = info.url; link.target = "_blank"; link.rel = "noopener"; blatt.appendChild(link); }
      dialog.appendChild(blatt); dialog.addEventListener("click", function(e) { if(e.target === dialog) schliessen(); }); document.body.appendChild(dialog);
    });
    text.appendChild(knopf);
  }
  // Dialogs retain keyboard focus, close with Escape, and restore focus.
  function dialogStart(dialog, blatt, titel) {
    var fokus = document.activeElement;
    var id = "nbx-dialog-titel";
    titel.id = id; blatt.setAttribute("role", "dialog");
    blatt.setAttribute("aria-modal", "true"); blatt.setAttribute("aria-labelledby", id);
    function zu() {
      if (dialog.parentNode) dialog.parentNode.removeChild(dialog);
      document.removeEventListener("keydown", tasten);
      if (fokus && fokus.isConnected) fokus.focus();
    }
    function tasten(e) {
      if (!dialog.isConnected) { document.removeEventListener("keydown", tasten); return; }
      if (e.key === "Escape") { e.preventDefault(); zu(); }
      if (e.key === "Tab") {
        var knoepfe = [].slice.call(blatt.querySelectorAll("button:not(:disabled), a[href], input:not(:disabled), select:not(:disabled), summary"));
        if (!knoepfe.length) { e.preventDefault(); return; }
        var erster = knoepfe[0], letzter = knoepfe[knoepfe.length - 1];
        if (e.shiftKey && document.activeElement === erster) { e.preventDefault(); letzter.focus(); }
        else if (!e.shiftKey && document.activeElement === letzter) { e.preventDefault(); erster.focus(); }
      }
    }
    document.addEventListener("keydown", tasten);
    setTimeout(function() { if (dialog.isConnected) { var b = blatt.querySelector("button"); if (b) b.focus(); } }, 0);
    return zu;
  }
  function plusVon(pos) {
    return pos.menge.querySelector('button[aria-label^="mehr"]');
  }
  function baueKarte(pos, kat, kompakt) {
    var info = Object.assign({ titel: kurzTitel(pos.titel) }, infoZu(pos.titel) || {}), karte = el("article", "nbx__karte" + (kompakt ? " nbx__karte--kompakt" : ""));
    var bildraum = el("div", "nbx__bildraum");
    if (info.bild || pos.bild) {
      var bild = document.createElement("img");
      bild.className = "nbx__bild"; bild.src = info.bild || pos.bild;
      bild.alt = kurzTitel(pos.titel); bild.loading = "lazy"; bildraum.appendChild(bild);
    }
    if (!kompakt && info.badges) info.badges.filter(function(b) { return /^(vegan|vegetarisch)$/i.test(b); }).slice(0,1).forEach(function(b) {
      bildraum.appendChild(el("span", "nbx__marke", b));
    });
    karte.appendChild(bildraum);
    info.naehrwertHinweis = info.naehrwertBasis + (pos.rolle === "essen_dressing" ? " · ohne Dressing" : "");
    var text = el("div", "nbx__text");
    text.appendChild(el("h3", "nbx__titel", kurzTitel(pos.titel)));
    if (!kompakt) {
      var basis = info.naehrwertBasis;
      if (basis && (info.kcal || info.protein)) {
        var naehr = el("div", "nbx__naehr");
        var werte = el("div", "nbx__naehr-werte");
        if (info.kcal) werte.appendChild(el("span", null, info.kcal + " kcal"));
        if (info.protein) werte.appendChild(el("span", null, String(info.protein).replace(/\s*g$/i, " g") + " Protein"));
        naehr.appendChild(werte);
        naehr.appendChild(el("span", "nbx__naehr-basis", basis + (pos.rolle === "essen_dressing" ? " · ohne Dressing" : "")));
        text.appendChild(naehr);
      }
      produktDetails(info, text);
    } else produktDetails(info, text);
    var fuss = el("div", "nbx__fuss"), preisbox = el("div", "nbx__preisbox");
    var anzeige = (pos.preis.match(/[\d.,]+\s*€/) || [pos.preis])[0];
    var hatZuschuss = pos.vollpreis > 0 && preisZahl(anzeige) < pos.vollpreis / 100;
    preisbox.appendChild(el("div", "nbx__preis", anzeige));
    preisbox.appendChild(el("div", "nbx__preis-basis", (kompakt ? "pro Becher · 100 ml" : "pro Bowl") + (hatZuschuss ? " · mit Zuschuss" : "")));
    if (hatZuschuss) preisbox.appendChild(el("div", "nbx__regulaer", "Regulär " + geld(pos.vollpreis / 100)));
    fuss.appendChild(preisbox); fuss.appendChild(pos.menge); text.appendChild(fuss); karte.appendChild(text);
    var plus = plusVon(pos);
    pos.rolle === "essen_dressing" && plus && plus.addEventListener("click", function() {
      pos.dressingFrage = true;
    });
    var anzeige = pos.menge.querySelector("output");
    function malen() {
      var m = Number(anzeige ? anzeige.textContent : 0) || 0, vorher = pos.aktuell || 0;
      karte.className = "nbx__karte" + (kompakt ? " nbx__karte--kompakt" : "") + (m > 0 ? " nbx__karte--aktiv" : ""), pos.aktuell = m, pos.dressingFrage && m !== vorher && (pos.dressingFrage = false, m > vorher && setTimeout(function() {
        dressingWahl(pos);
      }, 0)), summeMalen();
    }
    return anzeige && new MutationObserver(malen).observe(anzeige, { childList: true, characterData: true, subtree: true }), malen(), karte;
  }
  function dressingWahl(bowl) {
    var dressings = positionen.filter(function(p) {
      return p.rolle === "dressing";
    });
    if (!dressings.length || document.querySelector(".nbx__dialog")) return;
    var dialog = el("div", "nbx__dialog"), blatt = el("div", "nbx__blatt");
    var titel = el("h3", null, "Ihr Dressing");
    blatt.appendChild(titel); blatt.appendChild(el("p", "nbx__blatt-sub", kurzTitel(bowl.titel)));
    if (document.querySelector(".nico-zuschuss-info")) {
      var inklusive = el("div", "nbx__dressing-inklusive");
      inklusive.appendChild(el("strong", null, "Erstes Dressing inklusive"));
      inklusive.appendChild(el("span", null, "Zum bezuschussten Essen pro Liefertag bezahlt Ihre Firma ein Dressing. Weitere Dressings kosten den regulären Preis."));
      blatt.appendChild(inklusive);
    }
    var schliessen = dialogStart(dialog, blatt, titel);
    function zu() {
      schliessen();
    }
    var liste = el("div", "nbx__wahl");
    dressings.forEach(function(d) {
      var info = infoZu(d.titel) || {}, knopf = el("button", "nbx__wahl-knopf");
      if (knopf.type = "button", info.bild || d.bild) {
        var bild = document.createElement("img");
        bild.src = info.bild || d.bild, bild.alt = "", bild.className = "nbx__wahl-bild", knopf.appendChild(bild);
      }
      var name = el("span", "nbx__wahl-name", d.titel.replace(/^NICO\s+/i, "").replace(/\s*\d+\s*ml$/i, ""));
      info.allergene && name.appendChild(el("span", "nbx__wahl-unter", "Allergene: " + info.allergene));
      knopf.appendChild(name);
      var preis = el("span", "nbx__wahl-preis", d.preis);
      preis.appendChild(el("span", "nbx__wahl-unter", "regulär"));
      knopf.appendChild(preis);
      knopf.addEventListener("click", function() {
        var plus = plusVon(d);
        plus && !plus.disabled && plus.click(), zu();
      }), liste.appendChild(knopf);
    }), blatt.appendChild(liste);
    var akt = el("div", "nbx__aktionen"), ohne = el("button", "nbx__knopf nbx__knopf--linie", "Ohne Dressing");
    ohne.type = "button", ohne.addEventListener("click", zu), akt.appendChild(ohne), blatt.appendChild(akt), dialog.appendChild(blatt), dialog.addEventListener("click", function(e) {
      e.target === dialog && zu();
    }), document.body.appendChild(dialog);
  }
  var positionen = [], leisteZahl = null, leisteKnopf = null;
  function gewaehlt() {
    return positionen.filter(function(p) {
      return (p.aktuell || 0) > 0;
    });
  }
  function stueckzahl() {
    return gewaehlt().reduce(function(s, p) {
      return s + p.aktuell;
    }, 0);
  }
  function gesamt() {
    return gewaehlt().reduce(function(s, p) {
      return s + p.aktuell * preisZahl(p.preis);
    }, 0);
  }
  function summeMalen() {
    if (leisteZahl) {
      var stueck = aktuell ? aktuell.anzahl : stueckzahl();
      leisteZahl.textContent = (aktuell ? aktuell.kantinenbetragLabel : geld(gesamt()));
      var label = document.querySelector(".nbx__leiste-label");
      if (label) label.textContent = "In der Kantine zu zahlen · " + stueck + " Artikel";
      var status = document.querySelector(".nbx__leiste-status");
      if (status) status.textContent = abgeschlossen() ? "✓ Verbindlich bestellt" : stueck ? "Entwurf · bitte noch bestellen" : "Wählen Sie Ihre Bowl";
      leisteKnopf && (abgeschlossen() ? (leisteKnopf.textContent = "Bestellung ändern", leisteKnopf.className = "nbx__knopf nbx__knopf--linie", leisteKnopf.disabled = false) : (leisteKnopf.textContent = LEISTE_KNOPF, leisteKnopf.className = "nbx__knopf", leisteKnopf.disabled = stueck === 0));
    }
  }
  function leisteBauen() {
    var leiste = el("div", "nbx__leiste"), innen = el("div", "nbx__leiste-innen"), links = el("div");
    links.appendChild(el("div", "nbx__leiste-label", "Ihre Bestellung")), leisteZahl = el("div", "nbx__leiste-zahl", "0,00 €  ·  0 Artikel"), links.appendChild(leisteZahl), links.appendChild(el("div", "nbx__leiste-status")), innen.appendChild(links), leisteKnopf = el("button", "nbx__knopf", LEISTE_KNOPF), leisteKnopf.type = "button", leisteKnopf.addEventListener("click", function() {
      if (abgeschlossen() && portal()) {
        leisteKnopf.disabled = true, portal().aendern();
        return;
      }
      uebersicht();
    }), innen.appendChild(leisteKnopf), leiste.appendChild(innen), document.body.appendChild(leiste), summeMalen();
  }
  function fehlendeDressings() {
    var dressingKat = null;
    if (DATEN.kategorien.forEach(function(k) {
      /dressing/i.test(k.titel) && !k.marke && (dressingKat = k);
    }), !dressingKat) return null;
    var dressingStueck = 0, bowlStueck = 0;
    return gewaehlt().forEach(function(p) {
      var kn = kategorieVon(p.titel), k = kn ? katNach[kn] : null;
      k === dressingKat ? dressingStueck += p.aktuell : k && k.marke && !/inklusive/i.test(k.marke) && (bowlStueck += p.aktuell);
    }), bowlStueck > 0 && dressingStueck < bowlStueck ? bowlStueck + (bowlStueck === 1 ? " Bowl ohne Dressing" : " Bowls ohne Dressing") + " ausgewählt, aber nur " + dressingStueck + (dressingStueck === 1 ? " Dressing" : " Dressings") + " dazu. Poke Bowls bringen ihr Dressing selbst mit." : null;
  }
  function uebersicht() {
    var angezeigteBestellung = aktuell && aktuell.id;
    var tagBestaetigt = false;
    var dialog = el("div", "nbx__dialog"), blatt = el("div", "nbx__blatt"), mitAbschluss = !!portal(), noetig = !!(aktuell && aktuell.abschluss && aktuell.abschluss.noetig);
    var titel = el("h3", null, "Bestellung prüfen");
    blatt.appendChild(titel);
    var schliessen = dialogStart(dialog, blatt, titel);
    var tagAuswahl = document.getElementById("nico-liefertag");
    var aktuellerTag = tagAuswahl ? tagAuswahl.value : "";
    var tagbox = el("div", "nbx__datum-box"), tagfeld = el("label", "nbx__datum-feld");
    tagfeld.appendChild(el("span", null, "Lieferdatum wählen"));
    var tagwahl = el("select", "nbx__datum-auswahl"); tagwahl.id = "nbx-liefertag-checkout";
    var leer = el("option", null, "Bitte Datum auswählen"); leer.value = ""; tagwahl.appendChild(leer);
    if (tagAuswahl) [].slice.call(tagAuswahl.options).forEach(function(o) {
      var option = el("option", null, o.textContent); option.value = o.value; tagwahl.appendChild(option);
    });
    tagwahl.value = aktuellerTag; tagBestaetigt = !!tagwahl.value; tagfeld.appendChild(tagwahl); tagbox.appendChild(tagfeld);
    var tagok = el("button", "nbx__knopf nbx__datum-ok", "Übernommen ✓"); tagok.type = "button"; tagok.disabled = true;
    tagbox.appendChild(tagok); blatt.appendChild(tagbox);
    var taghinweis = el("p", "nbx__datum-hinweis nbx__datum-hinweis--ok", "Liefertag aus Ihrer Auswahl übernommen."); blatt.appendChild(taghinweis);
    tagwahl.addEventListener("change", function() {
      tagBestaetigt = !!tagwahl.value && tagwahl.value === aktuellerTag;
      ok.disabled = !tagBestaetigt; tagok.disabled = tagBestaetigt || !tagwahl.value;
      taghinweis.className = "nbx__datum-hinweis" + (tagBestaetigt ? " nbx__datum-hinweis--ok" : "");
      tagok.textContent = tagBestaetigt ? "Übernommen ✓" : "Tageswarenkorb öffnen";
      taghinweis.textContent = tagBestaetigt
        ? "Liefertag aus Ihrer Auswahl übernommen."
        : tagwahl.value ? "Jeder Liefertag hat einen eigenen Warenkorb. Der gewählte Tag wird geöffnet." : "Bitte Liefertag wählen.";
    });
    tagok.addEventListener("click", function() {
      if (!tagwahl.value) return;
      if (tagwahl.value !== aktuellerTag) {
        if (portal() && portal().liefertagWaehlen && portal().liefertagWaehlen(tagwahl.value)) schliessen();
        else taghinweis.textContent = "Der Warenkorb wird gerade aktualisiert. Bitte kurz warten.";
        return;
      }
      tagBestaetigt = true; ok.disabled = false;
      taghinweis.textContent = "✓ Liefertag bestätigt: " + tagwahl.selectedOptions[0].textContent;
      taghinweis.className = "nbx__datum-hinweis nbx__datum-hinweis--ok";
      tagok.textContent = "Bestätigt ✓";
    });
    blatt.appendChild(el("p", "nbx__blatt-sub", noetig ? "Mit „Verbindlich bestellen“ an die Küche senden." : "Änderungen sind bis zum Bestellschluss möglich."));
    aktuell && aktuell.positionen && aktuell.positionen.length && aktuell.positionen[0].gesamtLabel ? aktuell.positionen.forEach(function(p) {
      var z = el("div", "nbx__zeile");
      z.appendChild(el("div", "nbx__zeile-mg", p.menge + "×")), z.appendChild(el("div", "nbx__zeile-nm", p.titel)), z.appendChild(el("div", "nbx__zeile-pr", geld(p.gesamtCents / 100))), blatt.appendChild(z);
    }) : gewaehlt().forEach(function(p) {
      var z = el("div", "nbx__zeile");
      z.appendChild(el("div", "nbx__zeile-mg", p.aktuell + "×")), z.appendChild(el("div", "nbx__zeile-nm", p.titel)), z.appendChild(el("div", "nbx__zeile-pr", geld(p.aktuell * preisZahl(p.preis)))), blatt.appendChild(z);
    });
    var g = el("div", "nbx__gesamt");
    if (aktuell) {
      var regul = el("div", "nbx__abrechnung");
      regul.appendChild(el("span", null, "Warenwert")); regul.appendChild(el("span", null, geld(aktuell.summeCents / 100))); blatt.appendChild(regul);
      var firma = el("div", "nbx__abrechnung");
      firma.appendChild(el("span", null, "Firmenzuschuss")); firma.appendChild(el("span", null, "− " + geld((aktuell.summeCents - aktuell.kantinenbetragCents) / 100))); blatt.appendChild(firma);
    }
    g.appendChild(el("span", null, "In der Kantine zu zahlen")); g.appendChild(el("span", null, aktuell ? aktuell.kantinenbetragLabel : geld(gesamt()))); blatt.appendChild(g);
    var warn = fehlendeDressings();
    warn && blatt.appendChild(el("p", "nbx__warnung", warn));
    var fehler = el("p", "nbx__warnung");
    fehler.style.display = "none", blatt.appendChild(fehler);
    var akt = el("div", "nbx__aktionen"), zurueck = el("button", "nbx__knopf nbx__knopf--linie", "Weiter bearbeiten");
    zurueck.type = "button", zurueck.addEventListener("click", function() {
      schliessen();
    });
    var ok = el("button", "nbx__knopf", mitAbschluss ? "Verbindlich bestellen" : "Bestellung bestätigen");
    ok.type = "button"; ok.disabled = !tagBestaetigt; ok.addEventListener("click", function() {
      if (!tagBestaetigt || tagwahl.value !== aktuellerTag) return;
      if (!mitAbschluss) {
        bestaetigt(blatt, dialog, null);
        return;
      }
      ok.disabled = zurueck.disabled = true, portal().abschliessen(angezeigteBestellung).then(function(e) {
        if (ok.disabled = !tagBestaetigt, zurueck.disabled = false, e.ok) {
          bestaetigt(blatt, dialog, e);
          return;
        }
        fehler.textContent = e.text || "Das ging nicht.", fehler.style.display = "";
      });
    }), akt.appendChild(zurueck), akt.appendChild(ok), blatt.appendChild(akt), dialog.appendChild(blatt), dialog.addEventListener("click", function(e) {
      if (e.target === dialog) schliessen();
    }), document.body.appendChild(dialog);
  }
  function bestaetigt(blatt, dialog, ergebnis) {
    var summe = aktuell ? aktuell.summeLabel : geld(gesamt()), stueck = aktuell ? aktuell.anzahl : stueckzahl();
    blatt.innerHTML = "";
    var ok = el("div", "nbx__ok");
    ok.appendChild(el("div", "nbx__ok-haken", "✓")), ok.appendChild(el("h3", null, ergebnis ? "Verbindlich bestellt" : "Bestellung steht")), aktuell && aktuell.kantinenbetragLabel && ok.appendChild(el("p", "nbx__blatt-sub", "In der Kantine zu bezahlen: " + aktuell.kantinenbetragLabel)), ok.appendChild(el("p", "nbx__blatt-sub", summe + " · " + stueck + " Artikel sind für Sie bestellt.")), ergebnis && ok.appendChild(el("p", "nbx__blatt-sub", ergebnis.mailGewuenscht === false ? "Ihre Abholkarte finden Sie unter „Bestellungen & Abholkarten“." : ergebnis.mail === false ? "Die Bestätigungsmail konnte nicht verschickt werden – die Bestellung steht trotzdem." : "Ihre Abholkarte kommt per E-Mail. Ändern können Sie bis zum Bestellschluss über „Bestellung ändern“."));
    ok.querySelector("h3").id = "nbx-dialog-titel";
    var zu = el("button", "nbx__knopf", "Schließen");
    zu.type = "button", zu.addEventListener("click", function() {
      dialog.parentNode && document.body.removeChild(dialog);
    }), ok.appendChild(zu), blatt.appendChild(ok);
  }
  function umbauen(liste) {
    if (liste.getAttribute("data-nbx") !== "fertig") {
      var karten = [].slice.call(liste.querySelectorAll(".nico-artikel")), echte = karten.filter(function(k) {
        return k.querySelector(".nico-menge");
      });
      if (echte.length && (liste.setAttribute("data-nbx", "fertig"), positionen = [], echte.forEach(function(k) {
        var t = k.querySelector(".nico-artikel__titel"), pr = k.querySelector(".nico-artikel__preis"), mg = k.querySelector(".nico-menge"), im = k.querySelector("img");
        !t || !mg || positionen.push({ titel: (t.textContent || "").trim(), preis: (pr ? pr.textContent : "").trim(), menge: mg, bild: im ? im.src : "", id: k.getAttribute("data-produkt") || "", rolle: k.getAttribute("data-rolle") || "essen", vollpreis: Number(k.getAttribute("data-preis-cents")) || 0, aktuell: 0 });
      }), !!positionen.length)) {
        var huelle = el("div", "nbx"), gruppen = {}, reihenfolge = [];
        var navigation = el("nav", "nbx__kategorien"); navigation.setAttribute("aria-label", "Bowl-Kategorien"); huelle.appendChild(navigation);
        DATEN.kategorien.forEach(function(k) {
          reihenfolge.push(k.titel);
        }), reihenfolge.push("Weitere"), positionen.forEach(function(p) {
          var name = kategorieVon(p.titel) || "Weitere";
          gruppen[name] || (gruppen[name] = []), gruppen[name].push(p);
        }), reihenfolge.forEach(function(name) {
          var teil = gruppen[name];
          if (!(!teil || !teil.length)) {
            var kat = katNach[name] || null, kompakt = teil.every(function(p) {
              return p.rolle === "dressing";
            }), gruppe = el("section", "nbx__gruppe"), titel = el("h2", "nbx__gruppe-titel", name);
            gruppe.id = "nbx-gruppe-" + reihenfolge.indexOf(name);
            var link = el("a", "nbx__kategorie", name); link.href = "#" + gruppe.id; navigation.appendChild(link);
            var gruppenkopf = el("div", "nbx__gruppenkopf"); gruppenkopf.appendChild(titel);
            if (kat && kat.marke) gruppenkopf.appendChild(el("span", "nbx__gruppe-info", /inklusive/i.test(kat.marke) ? "Dressing inklusive" : "Dressing beim Hinzufügen wählen"));
            gruppe.appendChild(gruppenkopf);
            var raster = el("div", "nbx__raster" + (kompakt ? " nbx__raster--kompakt" : ""));
            teil.forEach(function(p) {
              raster.appendChild(baueKarte(p, kat, kompakt));
            }), gruppe.appendChild(raster), huelle.appendChild(gruppe);
          }
        }), liste.parentNode.insertBefore(huelle, liste), liste.style.display = "none";
        var alteSumme = host.querySelector(".nico-summe");
        alteSumme && (alteSumme.style.display = "none"), !aktuell && portal() && (aktuell = portal().bestellung() || null), document.querySelector(".nbx__leiste") || leisteBauen(), summeMalen();
      }
    }
  }
  function schauen() {
    for (var listen = host.querySelectorAll(".nico-liste"), i = 0; i < listen.length; i++) if (listen[i].querySelector(".nico-menge")) {
      umbauen(listen[i]);
      return;
    }
  }
  schauen(), new MutationObserver(schauen).observe(host, { childList: true, subtree: true });
})();
